<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                <v-icon class="me-2">mdi-filter</v-icon>
                Attendance Summary Filter
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form >
                  <v-row class="py-2 px-2 " align="center" dense>
                    <v-col cols="12" md="2">
                      <v-select
                        v-model="filters.year"
                        :items="yearOptions"
                        label="Year"
                        variant="outlined"
                        density="compact"
                        clearable
                        hide-details="auto"
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-select
                        v-model="filters.month"
                        :items="months"
                        item-title="label"
                        item-value="value"
                        label="Month"
                        variant="outlined"
                        density="compact"
                        clearable
                        hide-details="auto"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        v-model="filters.from_date"
                        label="From Date"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        hide-details="auto"
                        clearable
                        :max="filters.to_date"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        v-model="filters.to_date"
                        label="To Date"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        hide-details="auto"
                        clearable
                        :min="filters.from_date"
                      />
                    </v-col>
                    <v-col cols="12" md="2" class="d-flex align-end ga-2">
                      <v-btn
                      
                        @click="handleFilterSubmit"
                        color="primary"
                        :loading="listLoading"
                        prepend-icon="mdi-magnify"
                        class="pl-2"
                        density="compact"
                        height="40"
                        variant="flat"
                        
                      >
                        Search
                      </v-btn>

                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

      <v-row class="mt-2">
        <v-col cols="12">
          <v-expansion-panels v-model="listPanel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                <v-icon class="me-2">mdi-format-list-bulleted</v-icon>
                Attendance Summary List
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    />
                  </v-col>

                  <v-col md="5" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                        >
                          CSV
                        </v-btn>
                        <v-btn
                          prepend-icon="mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                        >
                          EXCEL
                        </v-btn>
                        <v-btn
                          prepend-icon="mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                        >
                          PDF
                        </v-btn>
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="3" cols="12">
                    <div class="text-right">
                      <v-btn
                        @click="router.push({ name: 'prepare-attendance' })"
                        color="primary"
                        variant="tonal"
                        prepend-icon="mdi-plus"
                        rounded="xl"
                      >
                        Prepare Attendance
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>

                <v-data-table
                  :headers="tableHeaders"
                  :items="attendanceSummaries"
                  :loading="listLoading"
                  :search="search"
                  class="mt-4"
                  density="compact"
                  hover
                  :items-per-page="itemsPerPage"
                  v-model:items-per-page="itemsPerPage"
                >
                  <template #item.index="{ index }">
                    {{ index + 1 }}
                  </template>
                  <template #loading>
                    <div class="py-6 text-center text-medium-emphasis">
                      Loading attendance summaries...
                    </div>
                  </template>
                  <template #item.code="{ item }">
                    <span class="font-weight-medium">{{ item.code }}</span>
                  </template>
                  <template #item.start_date="{ item }">
                    {{ formatDateDash(item.start_date) }}
                  </template>
                  <template #item.end_date="{ item }">
                    {{ formatDateDash(item.end_date) }}
                  </template>
                  <template #item.year_month="{ item }">
                    {{ getMonthName(item.month) }} {{ item.year }}
                  </template>
                  <template #item.status="{ item }">
                    <v-chip
                      :color="getStatusColor(item.status)"
                      size="small"
                      class="text-capitalize"
                    >
                      {{ item.status === 1 ? 'Active' : 'Inactive' }}
                    </v-chip>
                  </template>
                  <template #item.approval_status="{ item }">
                    <v-chip
                      :color="getApprovalStatusColor(item.approval_status)"
                      size="small"
                      class="text-capitalize"
                    >
                      {{ formatApprovalStatus(item.approval_status) }}
                    </v-chip>
                  </template>
                  <template #item.employee_count="{ item }">
                    {{ item.details_count || (item.details ? item.details.length : 0) }}
                  </template>
                  <template #item.actions="{ item }">
                    <v-btn
                      icon="mdi-eye"
                      size="small"
                      variant="text"
                      color="primary"
                      @click="viewDetails(item.id)"
                      class="me-1"
                    />
                    <v-btn
                      v-if="canEdit(item)"
                      icon="mdi-pencil"
                      size="small"
                      variant="text"
                      color="warning"
                      @click="editAttendance(item)"
                    />
                  </template>
                  <template #no-data>
                    <div class="py-6 text-center text-medium-emphasis">
                      No attendance summary records found. Try adjusting filters or prepare a new attendance.
                    </div>
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script setup>
import { ref, reactive, onMounted, computed, getCurrentInstance } from 'vue'
import { useRouter } from 'vue-router'
import { toast } from 'vue3-toastify'
import { useStore } from 'vuex'
import { formatDateDash } from "@/plugins/helpers";


const router = useRouter()
const store = useStore()
const instance = getCurrentInstance()
const panel = ref([0])
const listPanel = ref([0])
const listLoading = ref(false)
const itemsPerPage = ref(10)
const search = ref('')

// Options
const months = [
  { label: 'January', value: 1 },
  { label: 'February', value: 2 },
  { label: 'March', value: 3 },
  { label: 'April', value: 4 },
  { label: 'May', value: 5 },
  { label: 'June', value: 6 },
  { label: 'July', value: 7 },
  { label: 'August', value: 8 },
  { label: 'September', value: 9 },
  { label: 'October', value: 10 },
  { label: 'November', value: 11 },
  { label: 'December', value: 12 }
]

// Generate year options (from 2020 to current year + 5)
const currentYear = new Date().getFullYear()
const yearOptions = computed(() => {
  const years = []
  for (let year = 2020; year <= currentYear + 5; year++) {
    years.push(year)
  }
  return years.reverse() // Show most recent years first
})

// Data
const attendanceSummaries = ref([])
const filters = reactive({
  year: null,
  month: null,
  from_date: null,
  to_date: null
})

const tableHeaders = [
  { title: '#SL', key: 'index', sortable: false, width: '60px', align: 'center' },
  { title: 'Code', key: 'code', sortable: false, width: '120px' },
  { title: 'Start Date', key: 'start_date', sortable: false },
  { title: 'End Date', key: 'end_date', sortable: false },
  { title: 'Year / Month', key: 'year_month', sortable: false },
  { title: 'Status', key: 'status', sortable: false, align: 'center', width: '100px' },
  { title: 'Approval Status', key: 'approval_status', sortable: false, align: 'center', width: '130px' },
  { title: 'Employee Count', key: 'employee_count', sortable: false, align: 'center', width: '120px' },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center', width: '120px' }
]

// Methods
const fetchAttendanceSummaries = async () => {
  listLoading.value = true
  try {
    // Convert date objects to YYYY-MM-DD format for API
    const processedFilters = { ...filters }
    if (processedFilters.from_date instanceof Date) {
      processedFilters.from_date = processedFilters.from_date;
    }
    if (processedFilters.to_date instanceof Date) {
      processedFilters.to_date = processedFilters.to_date;
    }
    
    const sanitizedFilters = Object.fromEntries(
      Object.entries(processedFilters).filter(([, value]) => value !== null && value !== '')
    )
    const response = await store.dispatch('salaryReadyAttendance/getSalaryReadyAttendanceList', sanitizedFilters)

    if (response.success) {
      const data = response.data || []
      // Fetch employee counts for each attendance summary
      const summariesWithCounts = await Promise.all(
        data.map(async (item) => {
          try {
            // Fetch the details to get the employee count
            const detailResponse = await store.dispatch('salaryReadyAttendance/getSalaryReadyAttendanceById', item.id)
            if (detailResponse.success && detailResponse.data) {
              item.details_count = detailResponse.data.details?.length || 0
            } else {
              item.details_count = 0
            }
          } catch (error) {
            // If fetching details fails, set count to 0
            item.details_count = 0
          }
          return item
        })
      )
      attendanceSummaries.value = summariesWithCounts
    } else {
      attendanceSummaries.value = []
      toast.error(response.message || 'Failed to load attendance summaries')
    }
  } catch (error) {
    attendanceSummaries.value = []
    const errorMessage = error.response?.data?.message || error.message || 'Failed to load attendance summaries'
    toast.error(errorMessage)
  } finally {
    listLoading.value = false
  }
}

const handleFilterSubmit = () => {
console.log("Form submitted!");
  fetchAttendanceSummaries()
}

const resetFilters = () => {
  filters.year = null
  filters.month = null
  filters.from_date = null
  filters.to_date = null
  fetchAttendanceSummaries()
}

const getMonthName = (monthNumber) => {
  if (!monthNumber) return '—'
  const month = months.find(m => m.value === monthNumber)
  return month ? month.label : '—'
}

const getStatusColor = (status) => {
  return status === 1 ? 'success' : 'grey'
}

const formatApprovalStatus = (status) => {
  if (!status) return 'Pending'
  return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()
}

const getApprovalStatusColor = (status) => {
  if (!status) return 'orange'
  switch (status.toLowerCase()) {
    case 'pending':
      return 'orange'
    case 'approved':
      return 'success'
    case 'rejected':
    case 'cancelled':
      return 'error'
    default:
      return 'grey'
  }
}

const canEdit = (item) => {
  // Can edit if not approved
  return (!item.approval_status || item.approval_status.toLowerCase() !== 'approved' || item.status == 0)
}

const viewDetails = (id) => {
  if (!id) {
    toast.error('Attendance ID is missing')
    return
  }
  router.push({ 
    name: 'attendance-summary-details', 
    params: { id: id } 
  })
}

const editAttendance = (item) => {
  // Navigate to prepare attendance page with edit mode
  router.push({ 
    name: 'prepare-attendance',
    query: { 
      id: item.id,
      start_date: item.start_date,
      end_date: item.end_date,
      year: item.year,
      month: item.month
    }
  })
}

const hasActiveFilters = computed(() => {
  return Object.values(filters).some((value) => value !== null && value !== '')
})

// Export functions
const exportToPDF = () => {
  let serialNumber = 1
  const columns = [
    '#SL',
    'Code',
    'Start Date',
    'End Date',
    'Year / Month',
    'Status',
    'Approval Status',
    'Employee Count'
  ]
  const rows = attendanceSummaries.value.map((item) => [
    serialNumber++,
    item.code,
    formatDateDash(item.start_date),
    formatDateDash(item.end_date),
    `${getMonthName(item.month)} ${item.year}`,
    item.status === 1 ? 'Active' : 'Inactive',
    formatApprovalStatus(item.approval_status),
    item.details_count || 0
  ])
  
  instance.proxy.$exportTableToPDF(
    columns,
    rows,
    'Attendance Summary List',
    'attendance_summary_list_' + instance.proxy.$fileDate()
  )
}

const exportToExcel = () => {
  const data = [[
    '#SL',
    'Code',
    'Start Date',
    'End Date',
    'Year / Month',
    'Status',
    'Approval Status',
    'Employee Count'
  ]]
  let serialNumber = 1
  
  attendanceSummaries.value.forEach((item) => {
    data.push([
      serialNumber++,
      item.code,
      formatDateDash(item.start_date),
      formatDateDash(item.end_date),
      `${getMonthName(item.month)} ${item.year}`,
      item.status === 1 ? 'Active' : 'Inactive',
      formatApprovalStatus(item.approval_status),
      item.details_count || 0
    ])
  })
  
  instance.proxy.$exportTableToExcel(data, 'attendance_summary_list_' + instance.proxy.$fileDate())
}

const exportToCSV = () => {
  const data = [[
    '#SL',
    'Code',
    'Start Date',
    'End Date',
    'Year / Month',
    'Status',
    'Approval Status',
    'Employee Count'
  ]]
  let serialNumber = 1
  
  attendanceSummaries.value.forEach((item) => {
    data.push([
      serialNumber++,
      item.code,
      formatDateDash(item.start_date),
      formatDateDash(item.end_date),
      `${getMonthName(item.month)} ${item.year}`,
      item.status === 1 ? 'Active' : 'Inactive',
      formatApprovalStatus(item.approval_status),
      item.details_count || 0
    ])
  })
  
  instance.proxy.$exportTableToCSV(data, 'attendance_summary_list_' + instance.proxy.$fileDate())
}

// Lifecycle
onMounted(() => {
  // fetchAttendanceSummaries()
})
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}
</style>

